import React, { useRef, useLayoutEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import img from '../../images/culinaria_peixes.png';
import img2 from '../../images/culinaria_carnes.png';
import img3 from '../../images/culinaria_petiscos.png';
import { useTranslation } from 'react-i18next';

import { 
    WrapperCulinaria,
    TitleCulinaria,
    WrapperItems,
    ItemCulinaria,
    Img,
    TitleItem,
    TextItem,
    TitleSeparador
 } from './CulinariaElements';

const CulinariaSection = () => {
    const ref = useRef(null);
    const { t } = useTranslation();

    useLayoutEffect(() => {
        gsap.registerPlugin(ScrollTrigger);
        gsap.to(".title", {
            opacity: 1,
            scrollTrigger:{
                trigger: "#culinaria",
                start: "top center",
                end: "top 150px",
                scrub: true,
            }
        })
        return() => {
            gsap.killTweensOf(".title");
        }
    }, [])

    useLayoutEffect(() => {
        gsap.registerPlugin(ScrollTrigger);
        gsap.to(".cardOne", {
            x: 0,
            opacity: 1,
            scale: 1,
            scrollTrigger:{
                trigger: "#culinaria",
                start: "top 500px",
                end: "top 250px",
                scrub: true,
            }
        })
        return() => {
            gsap.killTweensOf(".cardOne");
        }
    }, [])

    useLayoutEffect(() => {
        gsap.registerPlugin(ScrollTrigger);
        gsap.to(".cardTwo", {
            x: 0,
            opacity: 1,
            scale: 1,
            scrollTrigger:{
                trigger: "#culinaria",
                start: "top 230px",
                end: "top 150px",
                // markers: true,
                scrub: true,
            }
        })
        return() => {
            gsap.killTweensOf(".cardTwo");
        }
    }, [])

    useLayoutEffect(() => {
        gsap.registerPlugin(ScrollTrigger);
        gsap.to(".cardThree", {
            x: 0,
            opacity: 1,
            scale: 1,
            scrollTrigger:{
                trigger: "#culinaria",
                start: "top 200px",
                end: "top 120px",
                // markers: true,
                scrub: true,
            }
        })
        return() => {
            gsap.killTweensOf(".cardThree");
        }
    }, [])


  return (
    <>

        <WrapperCulinaria ref={ref} id='culinaria'>

        <div 
            style={{
                display: "flex",
                width: "100%",
                border: 0,
                flexDirection: "column",
                alignItems: "center",
            }}
        >
            <TitleCulinaria className='title'>{t('culinaria.titulo')}</TitleCulinaria>
            <TitleSeparador className='title'>.</TitleSeparador>

            <WrapperItems>
                <ItemCulinaria 
                    className='cardOne'
                    style={{
                        opacity: 0,

                    }}
                    >
                    <Img src={img}/>
                    <TitleItem>{t('culinaria.peixeTitle')}</TitleItem>
                    <TextItem>{t('culinaria.peixeText')}</TextItem>
                </ItemCulinaria>

                <ItemCulinaria
                    className='cardTwo'
                    style={{
                        opacity: 0,
                    }}
                >
                    <Img src={img2}/>
                    <TitleItem>{t('culinaria.carneTitle')}</TitleItem>
                    <TextItem>{t('culinaria.carneText')}</TextItem>
                </ItemCulinaria>

                <ItemCulinaria
                    className='cardThree'
                    style={{
                        opacity: 0,

                    }}
                >
                    <Img src={img3}/>
                    <TitleItem>{t('culinaria.petiscoTitle')}</TitleItem>
                    <TextItem>{t('culinaria.petiscoText')}</TextItem>
                </ItemCulinaria>
            </WrapperItems>
            </div>

        </WrapperCulinaria>
      
    </>
  )
}

export default CulinariaSection
